var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialUi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 18l16 9v10l8 5 8-5V27l16-9v28l-16 9-16-9V36L8 27z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 27l8-5 8 5-8 5z",
    fill: "white",
    opacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialUi);
export default __webpack_public_path__ + "static/media/material-ui.8176e884fea62485fbdde79bfcb58004.svg";
export { ForwardRef as ReactComponent };